import { NgModule } from "@angular/core";
import { RouterModule, Routes } from "@angular/router";
import { LoggedInGuard, NonProdEnvironmentGuard } from "../auth/auth.guards";
import { PlaygroundComponent } from "./playground.component";

const routes: Routes = [
  {
    path: "",
    component: PlaygroundComponent,
    data: { title: "Playground" },
    canActivate: [NonProdEnvironmentGuard, LoggedInGuard],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class PlaygroundRoutingModule {}

const playgroundModuleLazyLoadRoutes: Routes = [
  {
    path: "playground",
    loadChildren: () =>
      import("./playground.module").then((m) => m.PlaygroundModule),
  },
];

export { playgroundModuleLazyLoadRoutes };
